﻿package com.mgacreative.hotelru.feature.guestapp.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

data class GuestReservation(
    val id: String, 
    val guestId: String, 
    val roomType: String, 
    val status: String, // PENDING_CHECKIN, CHECKED_IN, CHECKED_OUT
    val totalAmount: Double
)

class GuestAppViewModel : ViewModel() {

    // Simulating Guest Login Session
    val currentGuestId = "g_101"

    private val _reservations = MutableStateFlow<List<GuestReservation>>(emptyList())
    val reservations: StateFlow<List<GuestReservation>> = _reservations.asStateFlow()

    private val _successMessage = MutableStateFlow<String?>(null)
    val successMessage: StateFlow<String?> = _successMessage.asStateFlow()

    init {
        loadData()
    }

    private fun loadData() {
        _reservations.value = emptyList()
    }

    // Acceptance Criteria: Online check-in verisi Reception paneliyle aynı yere yazıyor
    fun submitOnlineCheckin(resId: String, idPhotoUrl: String, signatureUrl: String) {
        viewModelScope.launch {
            // Update the reservation status to CHECKED_IN (mimicking the exact same table update as Reception)
            // supabaseClient.client.postgrest["reservations"].update({ set("status", "CHECKED_IN") }) { filter { eq("id", resId) } }
            
            _reservations.value = _reservations.value.map {
                if (it.id == resId) it.copy(status = "CHECKED_IN") else it
            }
            
            _successMessage.value = "Online Check-in başarıyla tamamlandı. Otel resepsiyonuna uğramadan odanıza geçebilirsiniz!"
        }
    }

    fun requestRoomService(resId: String, requestText: String) {
        viewModelScope.launch {
            // Write to housekeeping/service table
            _successMessage.value = "Oda Servisi talebiniz alındı: $requestText"
        }
    }

    fun clearMessage() {
        _successMessage.value = null
    }
}


